import { render, staticRenderFns } from "./AddSubsidiaries.vue?vue&type=template&id=07da3615&"
import script from "./AddSubsidiaries.vue?vue&type=script&lang=js&"
export * from "./AddSubsidiaries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports